import { Component, Input } from '@angular/core';
import { Director } from '../../../core/models';
import { Company } from '../../../core/models';
import { Router } from '@angular/router';
import { ModalService } from '../../../core/services/modal.service';
import { methodology } from '../../../core/constants/methodology';
@Component({
  selector: 'app-company-info-summary',
  templateUrl: './company-info-summary.component.html',
  styleUrls: ['./company-info-summary.component.scss'],
})
export class CompanyInfoSummaryComponent {
  @Input() company: Company;
  constructor(
    private router: Router,
    private readonly modalService: ModalService
  ) {}

  openDirectorProfile(company: Company, director: Director) {
    let directorship = company.directorships?.find(
      directorship => directorship.id_director === director.id
    );
    if (!directorship) {
      throw new Error(`Directorship not found for director ${director}`);
    }
    directorship = { ...directorship, company: company };
    this.modalService.openDirectorProfile(directorship);
  }

  protected readonly methodology = methodology;
}
